<template>
<!-- Notificações com Dropdown -->
<el-dropdown trigger="click">
    <el-badge :value="notifications.length" class="notification">
        <span class="el-dropdown-link">
            <el-icon :size="24"><Bell /></el-icon>
        </span>
    </el-badge>
  <template #dropdown>
    <el-dropdown-menu class="notifications-dropdown">
      <template v-if="notifications.length">
        <el-dropdown-item
          v-for="(notification, index) in notifications"
          :key="index"
          @click="viewNotification(notification)"
        >
            <span v-if="notification.type == 'comment-task'">
                Um novo comentário em &nbsp;
            </span>
            {{ notification.title }}                  
        </el-dropdown-item>
      </template>
      <template v-else>
        <el-dropdown-item>Sem notificações</el-dropdown-item>
      </template>
    </el-dropdown-menu>
  </template>
</el-dropdown>    
</template>
<script>
import { ElDropdown, ElDropdownItem, ElDropdownMenu } from 'element-plus';
import { getNotificationsNotRead, updateReadNotification } from '../services/notificationService';

export default {
    components: {
        ElDropdown,
        ElDropdownItem,
        ElDropdownMenu
    },
    data() {
        return {
            notifications: []  
        }
    },
    methods: {
        async getNotification() {            
            try {      
                const response = await getNotificationsNotRead();        
                this.notifications = response.data;        
            } catch (error) {
                console.error(error);
                this.notifications = [];
                this.$message.error('Erro ao carregar notificações!');
            }
        },
        async viewNotification(notification) {
            // Ação ao clicar na notificação
            console.log("Visualizando notificação:", notification);
            try {
                const response = await updateReadNotification(notification.notification_id);

                if (response.success) {
                    this.getNotification();

                    this.$router.push({
                        name: 'TaskDetails',
                        params: {
                        id: notification.task_id,
                        slug: notification.task_slug
                        }
                    });
                }

            } catch (error) {
                console.error('[ERROR NO UPDATE DE NOTIFICACAO] ', error);
                this.$message.error('Erro ao abrir tarefa!');
            }
        },
    },
    mounted() {
        this.getNotification();
    }
}
</script>
<style scoped>
.notification {
    cursor: pointer;
}
</style>